import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN.json'
import enUS from './en-US.json'

// 定义消息类型，允许嵌套
type Messages = {
	[key: string]: string | Messages // 允许嵌套
}

const messages: Messages = {
	'zh-CN': zhCN,
	'en-US': enUS
}

const i18n = createI18n({
	legacy: false, // 使用 Composition API
	locale: localStorage.getItem('locale') || 'zh-CN', // 默认语言
	fallbackLocale: 'zh-CN', // 回退语言

	messages: messages as Record<string, any>
})
export default i18n
export const t = i18n.global.t
export const locale = i18n.global.locale
